export default __webpack_public_path__ + "static/media/hamburger.7d90c33c.svg";